import { render, staticRenderFns } from "./FpostgradCreate.vue?vue&type=template&id=1d78ad40&"
import script from "./FpostgradCreate.vue?vue&type=script&lang=js&"
export * from "./FpostgradCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports